import { preloadSharingDialogModule } from 'owa-sharing-dialog';
import { getSharingLinkInfo, preloadLinkData, SharingLinkInfo } from 'owa-link-data';
import { trace } from 'owa-trace';

export async function getSharingLinkInfoAndVerifyHref(
    anchorElement: HTMLAnchorElement
): Promise<SharingLinkInfo> {
    await preloadLinkData.import();

    let sharingLink: SharingLinkInfo = getSharingLinkInfo(anchorElement.id);
    if (sharingLink && anchorElement.href !== sharingLink.url) {
        sharingLink = null;
        trace.error('Stored url is different from the href on anchor element');
    }

    // We have to load the strings package before we can load the sharing dialog.
    // The .js file for the sharing dialog is also large, so to decrease response time on clicking
    // change permissions, we preload everything now. We do not need to await the import since this code will
    // not be used right away.
    preloadSharingDialogModule.import();

    return sharingLink;
}
